import { render, staticRenderFns } from "./Statements-live.vue?vue&type=template&id=ad9de82e"
import script from "./Statements-live.vue?vue&type=script&lang=js"
export * from "./Statements-live.vue?vue&type=script&lang=js"
import style0 from "./Statements-live.vue?vue&type=style&index=0&id=ad9de82e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports